export const REJECTED = 'Прекратен';//СИВ СТАТУС
export const APPROVE = 'Одобрен';//ЗЕЛЕН СТАТУС
export const CANCELED = 'Отхвърлен';//ЧЕРВЕН СТАТУС
export const FOR_CONFIRM = 'За одобрение първо ниво';//ЖЪЛТ СТАТУС
export const FOR_CONFIRM_REJECT = 'За одобрение на прекратяване първо ниво';//ЖЪЛТ СТАТУС
// export const REJECTED = 'Прекратен';//СИВ СТАТУС
// export const APPROVE = 'Одобрен';
// export const CANCELED = 'Отхвърлен';
// export const FOR_CONFIRM = 'Регистрирана';//ЖЪЛТ СТАТУС
//export const FOR_CONFIRM_HR = 'Одобрен от Ръководител';//ЖЪЛТ СТАТУС
//export const FOR_CONFIRM_MANAGER = 'За съгласуване от Ръководител';//ЖЪЛТ СТАТУС
//export const FOR_CONFIRM_REPLACEMENT = 'За съгласие от Заместник';//ЖЪЛТ СТАТУС
//export const REJECT_FROM_REPLACEMENT = 'Несъгласие от Заместник';//РОЗОВ СТАТУС
//export const REJECT_FROM_MANAGER = 'Неодобрен от Ръководител';//ЧЕРВЕН СТАТУС
//export const CONFIRM_FROM_RECTOR = 'Разрешен от Ректор';//ЗЕЛЕН СТАТУС
//export const REJECT_FROM_RECTOR = 'Неразрешен от Ректор';//ЧЕРВЕН СТАТУС
// export const FOR_CONFIRM_REJECT = 'За съгласуване от Ръководител';
//export const COMPLETE = 'Завършен';//ЗЕЛЕН СТАТУС 
